import { Component } from '@angular/core';
import { NetworkConnectionService } from '../../services/network-connection.service';

@Component({
    selector: 'app-no-network-connection-message',
    templateUrl: './no-network-connection-message.component.html',
    styleUrls: ['./no-network-connection-message.component.scss'],
    standalone: false
})
export class NoNetworkConnectionMessageComponent {

  constructor(private readonly networkConnectionService: NetworkConnectionService) {
  }

  public get hasNetworkConnection() {
    return this.networkConnectionService.hasNetworkConnection;
  }

}
